package linkerpangoquipdb

import kotlin.Long
import kotlin.String

public data class Vehicle_brand(
  public val id: Long,
  public val name: String,
  public val updated_at: Long,
)
